export const CREATE_ADMIN_SHARED_ACCESS = "CREATE_ADMIN_SHARED_ACCESS";   
export const RETRIEVE_ADMIN_SHARED_ACCESS = "RETRIEVE_ADMIN_SHARED_ACCESS";
export const RETRIEVESINGLE_ADMIN_SHARED_ACCESS = "RETRIEVESINGLE_ADMIN_SHARED_ACCESS";
export const UPDATE_ADMIN_SHARED_ACCESS = "UPDATE_ADMIN_SHARED_ACCESS";   
export const DELETE_ADMIN_SHARED_ACCESS = "DELETE_ADMIN_SHARED_ACCESS";   
